import React from 'react'

function Settings() {
  return (
    <div className="big-display">
        <div><i className="fa-solid fa-gear fa-2x"></i></div>
        
        <div className='heading1' >Settings</div>
    </div>
  )
}

export default Settings